import React from "react";
import { DropdownV2, InputV2 } from "../../../FormControlsV2";
import { DetachedTaskFiltersProps, MIN_DETACHED_TASK_DETAILS_LENGTH } from "./types";

export function DetachedTaskFilters({
  farmOptions,
  currentFarm,
  onFarmChange,
  farmLabel,
  allResponsibles,
  currentResponsible,
  onResponsibleChange,
  taskDetails,
  onTaskDetailsChange,
}: DetachedTaskFiltersProps) {
  const detailsLength = taskDetails?.length ?? 0;
  const detailsLabel =
    detailsLength < MIN_DETACHED_TASK_DETAILS_LENGTH
      ? `Detalhes da tarefa (${detailsLength}/${MIN_DETACHED_TASK_DETAILS_LENGTH} caracteres)`
      : "Detalhes da tarefa";

  return (
    <>
      <div className="filters-container filters-column">
        <div className="filters-dropdown filters-dropdown__full-width">
          <DropdownV2
            name="create-task-farm"
            label="Fazenda"
            placeholder="Selecionar fazenda"
            options={farmOptions}
            value={currentFarm ?? null}
            menuMount="overlay"
            onChange={(opt) => onFarmChange(opt?.value)}
          />
        </div>
        <div className="filters-dropdown filters-dropdown__full-width">
          <DropdownV2
            name="create-task-responsible"
            label="Responsável"
            placeholder="Selecionar responsável"
            options={allResponsibles}
            value={currentResponsible ?? null}
            menuMount="overlay"
            onChange={(opt) => onResponsibleChange(opt)}
          />
        </div>
      </div>
      <InputV2
        name="create-task-details"
        type="textarea"
        label={"Detalhes da tarefa (mínimo 8 caracteres)"}
        value={taskDetails}
        placeholder="Descreva a tarefa"
        onChange={(value) => onTaskDetailsChange(value)}
      />
    </>
  );
}
